import React from 'react';
import NoticePage from './pages/NoticePage';
import MainPage from './pages/MainPage';

function App() {
  // Determine which page to show based on hostname or path
  // 1. Subdomain check: notice.my-skku.xyz
  // 2. Path check: /notice (useful for local development)
  const isNoticeSubdomain = window.location.hostname.startsWith('notice');
  const isNoticePath = window.location.pathname.startsWith('/notice');
  
  const showNotice = isNoticeSubdomain || isNoticePath;

  return (
    <>
      {showNotice ? <NoticePage /> : <MainPage />}
    </>
  );
}

export default App;